const getScope = actionIndex => `run-ai-process-${actionIndex}`;

export const LoanActionRunAiProcessRowTestIds = {
  getProcessSelectId: actionIndex => `${getScope(actionIndex)}.process-select`,
  getTagSelectId: (actionIndex, tagKey) => `${getScope(actionIndex)}.${tagKey}-select`,
  getRerunSwitchId: actionIndex => `${getScope(actionIndex)}.rerun-switch`,
};
